/* LYNE Vendor Loader
   Aktiviert GSAP 3 + ScrollTrigger und Lenis nach Window-Load.
   Vendor-Files werden ueber theme.liquid als defer-Scripts vor diesem Loader geladen.
   Auftraggeber-Entscheidung 2026-05-14: Option A (self-hosted) aktiv.

   Verfuegbar nach Initialisierung:
   - window.lyneVendor.gsap          (GSAP 3.12.5)
   - window.lyneVendor.ScrollTrigger (Plugin registriert)
   - window.lyneVendor.lenis         (Lenis-Instanz, nur Desktop)
   - CustomEvent 'lyne:vendor:ready' am document

   Lenis: aktiv auf Desktop (>= 990px), deaktiviert auf Mobile und in prefers-reduced-motion.

   Stand: 2026-05-14. Builder Loop 2. */
(function () {
  'use strict';

  window.lyneVendor = window.lyneVendor || {
    status: 'loading',
    gsap: null,
    ScrollTrigger: null,
    lenis: null
  };

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function initVendor() {
    if (typeof window.gsap === 'undefined') {
      // GSAP nicht geladen, in 80 ms nochmal versuchen
      return setTimeout(initVendor, 80);
    }

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var Lenis = window.Lenis;

    window.lyneVendor.gsap = gsap;

    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      window.lyneVendor.ScrollTrigger = ScrollTrigger;
    }

    // Lenis nur auf Desktop und ohne reduced-motion
    if (Lenis && isDesktop() && !prefersReducedMotion()) {
      try {
        var lenis = new Lenis({
          duration: 1.2,
          easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
          smoothWheel: true,
          smoothTouch: false
        });

        function raf(time) {
          lenis.raf(time);
          if (ScrollTrigger) ScrollTrigger.update();
          requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        // ScrollTrigger ueber Lenis informieren
        if (ScrollTrigger) {
          lenis.on('scroll', ScrollTrigger.update);
          gsap.ticker.add(function (time) {
            lenis.raf(time * 1000);
          });
          gsap.ticker.lagSmoothing(0);
        }

        window.lyneVendor.lenis = lenis;
      } catch (err) {
        // Lenis-Init schlug fehl, koennen wir verkraften
        console && console.warn && console.warn('[LYNE] Lenis init failed:', err);
      }
    }

    window.lyneVendor.status = 'ready';
    document.dispatchEvent(new CustomEvent('lyne:vendor:ready', {
      detail: window.lyneVendor
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVendor);
  } else {
    initVendor();
  }
})();
